import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor, oceanBlueColor} from '../../cmsMainStyle'

const drawingDetailStyle = theme => ({

	coverArea: {
		marginTop: theme.spacing(1)
	},

	coverPaper: {
		minHeight: theme.spacing(10),
		padding: theme.spacing(1)
	},

	coverContent: {
		display: "flex",
		alignItems: "center",
	},

	drawingArea: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		marginLeft: theme.spacing(2),
		marginRight: theme.spacing(2)
	},


	drawingCategoryArea: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		marginLeft: theme.spacing(2),
		marginRight: theme.spacing(2)
	},

	drawingType: {
		display: "flex",
		alignItems: "center",
	},

	ToggleButtonGroup: {
		width: "100%"
	},

	ToggleButton: {
		width: "25%",

		"&.Mui-selected": {
			backgroundColor: oceanBlueColor[1]
		}

	},
})


export default drawingDetailStyle